// extracted by mini-css-extract-plugin
module.exports = {"sp-220w-double":"SP220wDouble_sp-220w-double__YExci"};